function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  id: "Oval",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#BFC7E0",
  strokeWidth: 1
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Arrow-Back-Outline",
  transform: "translate(8 9)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.9375 6.00073L3.33625 6.00073L7.19312 1.64113L7.19312 1.64113C7.56868 1.2159 7.50684 0.584682 7.055 0.231254C6.60316 -0.122176 5.93243 -0.0639783 5.55688 0.361242L0.244375 6.36069L0.244375 6.36069C0.208633 6.40841 0.176672 6.45855 0.14875 6.51068C0.14875 6.56068 0.14875 6.59067 0.074375 6.64067L0.074375 6.64067C0.0262156 6.75532 0.00099992 6.87736 1.04455e-09 7.00064L0 7.00064L1.40404e-08 7.00064C0.00100018 7.12392 0.026216 7.24596 0.0743757 7.3606C0.0743757 7.4106 0.0743757 7.4406 0.148751 7.49059L0.148751 7.49059C0.176673 7.54273 0.208634 7.59286 0.244376 7.64058L5.55688 13.64L5.55688 13.64C5.75913 13.8686 6.05898 14.0005 6.375 14L6.375 14C6.62325 14.0005 6.86384 13.9191 7.055 13.77L7.055 13.77C7.50674 13.4176 7.56934 12.7872 7.19482 12.3621C7.19426 12.3614 7.19369 12.3608 7.19312 12.3601L3.33625 8.00054L15.9375 8.00054L15.9375 8.00054C16.5243 8.00054 17 7.55287 17 7.00063C17 6.4484 16.5243 6.00073 15.9375 6.00073L15.9375 6.00073Z",
  transform: "translate(4 5)",
  id: "Path",
  fill: "#636E95",
  fillRule: "evenodd",
  stroke: "none"
}));

var SvgBackButton = function SvgBackButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "-2 -2 44 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-button.0b9a85b6.svg";
export { ForwardRef as ReactComponent };